var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"chat-float-entry",on:{"click":_vm.goChat}},[_c('div',{staticClass:"bubble"},[_c('van-icon',{attrs:{"name":"chat-o","size":"26","color":"#fff"}})],1),(_vm.unread > 0)?_c('span',{staticClass:"badge"},[_vm._v(_vm._s(_vm.unread > 99 ? '99+' : _vm.unread))]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }